import { render, staticRenderFns } from "./infoRegistrationPage.vue?vue&type=template&id=465595f8&scoped=true&"
import script from "./infoRegistrationPage.vue?vue&type=script&lang=js&"
export * from "./infoRegistrationPage.vue?vue&type=script&lang=js&"
import style0 from "./infoRegistrationPage.vue?vue&type=style&index=0&id=465595f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465595f8",
  null
  
)

export default component.exports